import styled from "styled-components";
import { Button } from "@material-ui/core";
import {
  DeleteOutline,
  DoneOutline,
  StopRounded,
  Close,
} from "@material-ui/icons";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  overflow: auto;
`;

export const Content = styled.div`
  font-size: 70px;

  @media (max-width: 1228px) {
    font-size: 42px;
  }
`;

export const Title = styled.span`
  font-size: 70px;

  @media (max-width: 1228px) {
    font-size: 42px;
  }
`;

export const Timer = styled.strong`
  font-size: 120px;

  @media (max-width: 1228px) {
    font-size: 78px;
  }
`;

export const Actions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export const CancelAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    font-size: 22px;
    font-weight: bold;
    color: ${(props) => props.color};
  }

  &:hover {
    filter: brightness(1.1);
  }
`;

export const FinishAction = styled(CancelAction)``;

export const SendAction = styled(CancelAction)``;

export const BorderedButton = styled(Button).attrs({
  variant: "outlined",
  component: "label",
})`
  height: 100px;
  width: 100px;
  border-radius: 50%;
  border-width: 3px;
  border-color: ${(props) => props.color};

  svg {
    color: ${(props) => props.color};
    font-size: 80px;
  }

  @media (max-width: 1228px) {
    height: 80px;
    width: 80px;
  }
`;

export const ActionTitle = styled.p`
  color: ${(props) => props.color};
`;

export const TrashIcon = styled(DeleteOutline)`
  @media (max-width: 1228px) {
    height: 40px;
    width: 40px;
  }
`;

export const SendIcon = styled(DoneOutline)`
  @media (max-width: 1228px) {
    height: 40px;
    width: 40px;
  }
`;

export const StopIcon = styled(StopRounded)`
  @media (max-width: 1228px) {
    height: 40px;
    width: 40px;
  }
`;

export const CloseIcon = styled(Close)`
  @media (max-width: 1228px) {
    height: 40px;
    width: 40px;
  }
`;
